module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-Italic-2a6e6f28a4817bd8178db513403e1593.woff";